import { Component } from 'preact';
import PropTypes from 'prop-types';
import { loadScriptReCAPTCHA } from '%/utils/reCAPTCHA';
import ConversionForm from './ConversionForm';

class ConversionFormApp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmittingForm: false,
      errorSendingForm: false,
      showOverlay: false,
    };

    window.store.SearchFilter.watch(state => {
      this.setState({
        showConversionForm: state.showConversionForm,
        keyword: state.keyword,
      });
    });

    this.handleCloseOverlay = this.handleCloseOverlay.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    loadScriptReCAPTCHA();
  }

  handleCloseOverlay() {
    this.setState({ showOverlay: false });
  }

  handleSubmit(e, params) {
    this.setState({ isSubmittingForm: true });

    const customParms = {
      ...params,
      product: params.product || this.state.keyword || 'Produto não informado',
    };

    // eslint-disable-next-line no-undef
    return serviceConversion
      .convert(customParms)
      .then(() => {
        this.setState({
          isSubmittingForm: false,
          errorSendingForm: false,
        });
      })
      .catch(error => {
        this.setState({
          isSubmittingForm: false,
          errorSendingForm: true,
        });
        console.error(error);
      })
      .then(() => {
        this.setState({
          showOverlay: true,
        });
      });
  }

  render() {
    const {
      isSubmittingForm,
      errorSendingForm,
      showOverlay,
      showConversionForm,
    } = this.state;
    const {
      formId,
      mainPhrase,
      linkPrivacyPolicy,
      units,
      channel,
      category,
      showUnits,
      showCpf,
      title,
      buttonLabel,
      showMessageField,
      showLabels,
    } = this.props;

    if (showConversionForm) {
      return (
        <div className="conversion-form-no-result">
          <ConversionForm
            className="form-conversion--light"
            titleForm={title}
            formId={formId}
            isSubmittingForm={isSubmittingForm}
            errorSendingForm={errorSendingForm}
            showOverlay={showOverlay}
            handleSubmit={this.handleSubmit}
            handleCloseOverlay={this.handleCloseOverlay}
            mainPhrase={mainPhrase}
            checkStyle="dark"
            linkPrivacyPolicy={linkPrivacyPolicy}
            units={units}
            channel={channel}
            category={category}
            showUnits={showUnits}
            showCpf={showCpf}
            versions={this.props.versions}
            shouldShowDataPermissions={this.props.shouldShowDataPermissions}
            dataPermissionsCustomText={this.props.dataPermissionsCustomText}
            buttonLabel={buttonLabel}
            showMessageField={showMessageField}
            showLabels={showLabels}
          />
        </div>
      );
    }

    return null;
  }
}

ConversionFormApp.defaultProps = {
  mainPhrase:
    'Preencha o formulário abaixo e um de nossos consultores entrarão em contato para te ajudar.',
  units: [],
  showUnits: true,
  showCpf: false,
  versions: [],
  shouldShowDataPermissions: false,
  title: 'Não encontrou o que procurava?',
  buttonLabel: 'ENVIAR SOLICITAÇÃO',
  showMessageField: true,
  showLabels: false,
};

ConversionFormApp.propTypes = {
  formId: PropTypes.string.isRequired,
  mainPhrase: PropTypes.string,
  linkPrivacyPolicy: PropTypes.string,
  // eslint-disable-next-line react/no-typos
  channel: PropTypes.channel,
  // eslint-disable-next-line react/no-typos
  category: PropTypes.category,
  units: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    }),
  ),
  showUnits: PropTypes.bool,
  showLabels: PropTypes.bool,
  showCpf: PropTypes.bool,
  versions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    }),
  ),
  shouldShowDataPermissions: PropTypes.bool,
  dataPermissionsCustomText: PropTypes.string,
  title: PropTypes.string,
  buttonLabel: PropTypes.string,
  showMessageField: PropTypes.bool,
};

export default ConversionFormApp;
